var _rect, _rect2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisibilityOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-672 -314)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2498 7.73008C12.2798 7.47008 11.3398 7.54008 10.5098 7.84008L12.2598 9.59008C13.4498 9.70008 14.3798 10.6401 14.4998 11.8301L16.2498 13.5801C16.5498 12.7501 16.6198 11.8101 16.3598 10.8401C15.9598 9.34008 14.7498 8.12008 13.2398 7.72008L13.2498 7.73008Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2897 16.0401C15.7497 17.0201 13.9497 17.5701 12.0297 17.5701C8.32971 17.5701 5.01971 15.5401 3.32971 12.3101C3.24971 12.1601 3.24971 11.9801 3.32971 11.8301C4.44971 9.68008 6.29971 8.09008 8.48971 7.24008L6.95971 5.71008C4.52971 6.87008 2.54971 8.84008 1.37971 11.2701C1.13971 11.7701 1.13971 12.3701 1.37971 12.8701C3.28971 16.8301 7.33971 19.5701 12.0297 19.5701C14.5197 19.5701 16.8197 18.7901 18.7297 17.4801L17.2897 16.0401V16.0401Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6795 11.2701C20.7695 7.31007 16.7195 4.57007 12.0295 4.57007C10.5995 4.57007 9.22947 4.83007 7.95947 5.29007L9.55947 6.89007C10.3495 6.69007 11.1795 6.57007 12.0295 6.57007C15.7295 6.57007 19.0395 8.60007 20.7295 11.8301C20.8095 11.9801 20.8095 12.1601 20.7295 12.3101C20.0795 13.5501 19.1795 14.6101 18.1195 15.4501L19.5295 16.8601C20.8395 15.7701 21.9295 14.4101 22.6695 12.8601C22.9095 12.3601 22.9095 11.7601 22.6695 11.2601L22.6795 11.2701Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68974 13.2901C8.08974 14.7901 9.29974 16.0101 10.8097 16.4101C12.8597 16.9601 14.7797 16.0701 15.7897 14.5301L14.3197 13.0601C14.0297 13.7501 13.4297 14.3001 12.7097 14.4901C11.0397 14.9201 9.53974 13.6701 9.53974 12.0801C9.53974 11.0501 10.1597 10.1801 11.0397 9.79008L9.57974 8.33008C8.04974 9.34008 7.15974 11.2501 7.69974 13.3101L7.68974 13.2901Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0287 3.64901C4.60277 3.22307 3.94089 3.19436 3.55037 3.58489C3.15984 3.97541 3.18855 4.63728 3.61449 5.06322L19.039 20.4877C19.465 20.9137 20.1268 20.9424 20.5173 20.5519C20.9079 20.1613 20.8792 19.4995 20.4532 19.0735L5.0287 3.64901Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityOff);
export default __webpack_public_path__ + "static/media/icon-visibility-off.defdeb9fe4d21b6e4ab08fe6545d4b3e.svg";
export { ForwardRef as ReactComponent };